import React from "react";
// import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
// import * as urlService from "../../view/urlService";
// import {showInfoToast, showSuccessToast, showWarningToast, showDangerToast} from "../../validation/ToastContainer";
// import {PopupContext, TableContext} from "../../index";
// import {getConfirmPopup, POPUP_TYPES} from "../../view/popup/PopupContainer";
// import * as ruleService from "../ruleService";
// import {useRemediationTableHelper} from "./useRemediationTableHelper";

function RemediationTableHeader({ userCapability }) {

    // const initialState = {
    //     parameterName: null,
    //     parameterValue: null,
    //     selectedParameter: null,
    // }

    // const history = useHistory();
    // const {setPopup} = useContext(PopupContext);
    // const [state, setState] = useState(initialState);
    // const {config} = useContext(TableContext);
    // const [lastUpdated, setLastUpdated] = useState(Date.now);
    // const [parameters, setParameters] = useState([]);
    // const helper = useRemediationTableHelper();

    // const [tableTitle, setTableTitle] = useState('Parameters');
    // const location = useLocation();

    //#region Set User Capabilities
    // const [manageParameterCapability, setManageParameterCapability] = useState(-1);
    // useEffect(() => {
    //     if (userCapability) {
    //         const manageParameterPermission = userCapability.find(item =>
    //             item.component === "manageparameter" && item.type === "page")?.permission;
    //         setManageParameterCapability(manageParameterPermission);
    //     }
    // }, []);
    //#endregion

    // useEffect(() => {
    //     setTableTitle(urlService.getParams().tableTitle || 'Parameters');
    // }, [location.search])


    return (
        <>
            <div className="oct_analysis-header-v2">
                <div className="oct_analysis-title-section">
                    <h2>REMEDIATION HISTORY REPORT</h2>
                </div>
            </div>
            {/*
            <div className="mr-4 mb-4 mt-4">
                <SearchInputV2
                    value={searchTerm}
                    onChange={(e) => {
                        const value = e.target.value;
                        setSearchTerm(value);
                        setConfig({ ...config, searchTerm: value });
                    }}
                    placeholder="Search by rule name, device, or severity..."
                />
            </div>
            */}
        </>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default connect(mapStateToProps)(RemediationTableHeader);
